import React from 'react';

const TagsContext = React.createContext({
    tags: [],
    setTags: (tags) => undefined,
    clearTags: () => undefined,
});

export default TagsContext;
